export interface IDateRange {
    from: Date;
    to: Date;
}

export const instanceOfDateRange = (value: any): value is IDateRange => {
    return !value || Object.keys(value).some((x) => x === 'from');
};
